import { reactive, ref, toRefs, nextTick } from 'vue'
import { Message } from 'view-design'
import { MessageBox } from 'element-ui'
import moment from 'moment'

import { COMMENT_TYPES, VISIBLE_TYPES, REPLY_TYPES, REPLY_LEVEL_TYPES } from '../data/material-comments-const.js'
import {
  getMaterialAnalysisCommentList,
  materialCommentSetTop,
  materialCommentReply,
  materialCommentSetInvisible
} from '@/api/report.model'

const defaultDate = moment().subtract(1, 'days').format('YYYY-MM-DD')

const pager = ref({
  total: 0,
  pageSize: 50,
  pageIndex: 1
})

const tableData = ref([])

export const useCommentQueryForm = (route) => {
  const imageName = route.query.imageName ? decodeURIComponent(route.query.imageName) : ''

  const formModel = reactive({
    form: {
      imageNames: imageName,
      accountIdList: [],
      commentTypeList: [],
      replyStatusList: [],
      hideStatusList: [],
      launchOpIds: [],
      datetime: [defaultDate, moment().format('YYYY-MM-DD')]
    },
    summryData: {},
    tableLoading: false
  })

  function queryAction() {
    const { datetime, ...formFileds } = formModel.form
    const [beginTime, endTime] = datetime
    const { pageIndex, pageSize } = pager.value

    formModel.tableLoading = true

    getMaterialAnalysisCommentList({ ...formFileds, pageIndex, pageSize, beginTime, endTime })
      .then((data) => {
        const { list, page_info, sum_data } = data || {}
        formModel.tableLoading = false

        if (list.length) {
          tableData.value = list.map((i) => {
            const commentTypeText = i.commentType ? COMMENT_TYPES.find((t) => t.id === i.commentType).name : '未知'
            const commentReplyStatusText = i.replyStatus ? REPLY_TYPES.find((t) => t.id === i.replyStatus).name : '未回复'
            const commentVisibleStatusText = i.hideStatus ? VISIBLE_TYPES.find((t) => t.id === i.hideStatus).name : '未知'
            const commentLevelText = i.commentLevel ? REPLY_LEVEL_TYPES.find((t) => t.id === i.commentLevel).name : '未知'
            return {
              ...i,
              images: i.commentImage ? JSON.parse(i.commentImage) : [],
              commentTypeText,
              commentReplyStatusText,
              commentVisibleStatusText,
              commentLevelText,
              formatedCreateTime: moment(i.createTime).format('YYYY-MM-DD HH:mm:ss')
            }
          })
          pager.value.total = page_info.total_number
          formModel.summryData = sum_data
        } else {
          tableData.value = []
          formModel.summryData = {}
          pager.value.total = 0
        }
      })
      .catch(() => {
        formModel.tableLoading = false
      })
  }

  return {
    ...toRefs(formModel),
    queryAction
  }
}
export const useCommentTable = (queryAction) => {
  const tableSelections = ref([])
  const tableModel = reactive({
    replyCommentsDialogVisible: false,
    tableSelections,
    setTopLoading: false,
    replyComments: '',
    replyLoading: false
  })

  function onSelectionChange(selection) {
    tableModel.tableSelections = selection
  }

  function onCommentReply(row) {
    tableModel.replyCommentsDialogVisible = true
    tableModel.tableSelections = [row]
  }
  function onCommentHide(row) {
    onBatchHideComments([row])
  }
  function onCommentSetTop(row, flag) {
    if (tableModel.setTopLoading) return
    MessageBox.confirm(`确定将评论${flag ? '置顶' : '取消置顶'}？`, '确认', {
      type: 'warning'
    }).then(() => {
      materialCommentSetTop({ id: row.id, stickStatus: flag ? 1 : 0 })
        .then((data) => {
          if (data?.success) {
            tableData.value = tableData.value.map((i) => {
              if (i.id === row.id) {
                i.stickStatus = flag ? 1 : 0
              }
              return i
            })
          }
          tableModel.setTopLoading = false
        })
        .catch(() => {
          tableModel.setTopLoading = false
        })
    })
  }

  /**
   * @description: 批量回复
   * @return {*}
   */
  function onBatchReplyComments() {
    if (tableModel.tableSelections.length === 0) {
      return Message.warning('请选择要回复的评论')
    }
    tableModel.replyCommentsDialogVisible = true
  }

  function onReplyCommentConfirm() {
    const selections = tableModel.tableSelections
    if (selections?.length === 0) return Message.warning('请选择要回复的评论')
    const text = tableModel.replyComments.trim()
    if (!text) return Message.warning('请输入回复内容')
    if (text.length > 100) return Message.warning('回复内容不能超过100个字')
    tableModel.replyLoading = true
    materialCommentReply({ ids: selections.map((i) => i.id), text })
      .then((data) => {
        if (data) {
          onReplyCommentCancel()
          queryAction()
          tableModel.replyLoading = false
        }
      })
      .catch((e) => {
        tableModel.replyLoading = false
      })
  }
  function onReplyCommentCancel() {
    tableModel.replyCommentsDialogVisible = false
    tableModel.replyComments = ''
  }

  /**
   * @description: 批量隐藏
   * @return {*}
   */
  function onBatchHideComments(selections) {
    if (!selections) selections = tableModel.tableSelections
    if (selections.length === 0) return Message.warning('请选择要隐藏的评论')
    MessageBox.confirm(
      '隐藏后，该评论及评论下的回复将在投放视频下方评论区中隐藏，仅评论发布者可见，其他用户均不可见。隐藏后不可恢复，是否隐藏？',
      '确认',
      {
        type: 'warning'
      }
    ).then(() => {
      const ids = selections.map((i) => i.id)
      materialCommentSetInvisible({ ids, hideStatus: 1 }).then((data) => {
        if (data) {
          queryAction()
        }
      })
    })
  }
  return {
    ...toRefs(tableModel),
    pager,
    tableData,
    onSelectionChange,
    onCommentReply,
    onCommentHide,
    onCommentSetTop,
    onBatchHideComments,
    onBatchReplyComments,
    onReplyCommentConfirm,
    onReplyCommentCancel
  }
}
